import { createFileRoute } from '@tanstack/react-router'
import BackgroundJobs from 'Royalty/components/Reports/BackgroundJobs'

export const Route = createFileRoute('/royalty/backgroundjobs')({
    component: BackgroundJobs,
})
